import authRequest from "@/api/http/authRequest";

export default {
  searchNotices(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/notices`, params, cb, errCb)
  },
  addNotice(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.post(`/admin/notice`, params, cb, errCb)
  },
  updateNotice(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/notice/${params.id}`, params, cb, errCb)
  },
  findNotice(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/notice/${id}`, {}, cb, errCb)
  },
  deleteNotice(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.delete(`/admin/notice/${id}`, cb, errCb)
  },
}
